import { render, staticRenderFns } from "./EventFeedbackForm.vue?vue&type=template&id=552cb6e1&scoped=true"
import script from "./EventFeedbackForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventFeedbackForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventFeedbackForm.vue?vue&type=style&index=0&id=552cb6e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552cb6e1",
  null
  
)

export default component.exports